/**
 * Aide contextuelle — Calendrier unifié
 */

const calendarHelp = {
  '/calendar': {
    title: 'Calendrier unifié',
    user: [
      {
        heading: 'A quoi sert cette page ?',
        content: `Vue calendrier unifiée qui agrège : **rendez-vous Assistant** (prospects, commerciaux), **tâches ticketing** (interventions planifiées), **rappels** (follow-ups programmés), et si configuré, les événements **Outlook** de l'utilisateur connecté.`,
      },
      {
        heading: 'Navigation',
        content: `Vue **Mois** (défaut), **Semaine**, **Jour**. Drag pour déplacer un événement → mise à jour automatique côté serveur. Clic sur une date vide → création rapide.`,
      },
      {
        heading: 'Vue équipe (administrateurs)',
        content: `Une ligne par personne et par calendrier partagé (Support, Admin) ; les comptes de test n'y figurent pas. **Jour**, **Semaine** ou **Mois** : le mois montre la charge de chacun (chiffre = nombre d'événements du jour, case hachurée « A » = absent, par exemple l'école d'un alternant) ; un clic sur une case ouvre ce jour en détail. Pour changer l'ordre des personnes, **maintenir le clic sur un nom et le glisser** sur une autre personne : l'ordre est retenu sur votre compte (bouton « Reset » dans Préférences pour revenir à l'ordre par défaut). Les agendas Outlook des collègues sont lus directement, sans qu'ils aient à « connecter Outlook » ; un événement privé n'affiche que « Occupé (privé) ».`,
      },
      {
        heading: 'Sources affichées',
        content: `Cases à cocher en haut pour filtrer par source : **Tâches** (orange), **RDV Assistant** (bleu), **Outlook** (vert), **Rappels** (violet). Désactivable individuellement.`,
      },
      {
        heading: 'Couleurs par priorité',
        content: `Tâches urgentes en rouge, normales en orange, basses en gris. RDV confirmés en vert soutenu, pending en vert clair, annulés barrés.`,
      },
      {
        heading: 'Popups de rappel',
        content: `Pour chaque RDV (ou intervention de ticket), jusqu'à **2 popups** peuvent s'afficher :\n\n**Popup vert "Imminent"** — 15 min avant l'heure du RDV.\n**Popup rouge "En retard"** — au moment où le RDV passe son heure si toujours actif.\n\nUne alerte 1h avant est aussi créée mais elle reste dans la cloche, sans popup.\n\nActions du popup :\n- **Rappeler...** (5/15/30 min, 1h, cet après-midi, demain) — cache le popup et le rappelle au moment voulu.\n- **X (fermer)** — silence définitif pour ce RDV.\n- **Voir le RDV / le ticket** — ouvre la fiche (snooze 15 min en parallèle).\n\n**Synchronisation entre onglets** : un snooze ou X dans **un onglet** se propage **immédiatement** aux autres onglets du même navigateur, et au plus en 30s aux autres appareils. Snoozer le popup rouge silence aussi le popup vert frère du même RDV.`,
      },
    ],
    admin: [
      {
        heading: 'Synchronisation Outlook',
        content: `Via MS Graph application permissions (app-only flow). Configuration : \`AUTH_MICROSOFT_TENANT\`, \`AUTH_MICROSOFT_CLIENT_ID\`, \`AUTH_MICROSOFT_CLIENT_SECRET\`. L'utilisateur doit avoir une licence O365 avec calendrier activé.`,
      },
      {
        heading: 'Endpoints',
        content: `\`GET /api/calendar/events?from=X&to=Y\` — Fusion des 4 sources.\n\`POST /api/calendar/events\` — Création (demande la source).\n\`PUT /api/calendar/events/{id}\` — Modif (drag de l'UI).\n\`GET /api/calendar/public/{token}\` — Partage public (sans auth).`,
      },
      {
        heading: 'Synchronisation tasks',
        content: `Les tâches de tickets avec \`planned_start_at\` renseigné sont syncées vers Outlook de l'assigné via \`sync_task_to_calendars()\`. La date de modification ou suppression propage automatiquement vers Outlook.`,
      },
    ],
  },

};

export default calendarHelp;
